import React, { useEffect } from "react";
import { useState } from "react";
import { Form, Offcanvas, Table } from "react-bootstrap";
import { FaEdit, FaTrash } from "react-icons/fa";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import { studyEDCDashboardGraph } from "../../../../APIServices/studyEDCDashboardGraph";
import { useParams } from "react-router";
import Pagination from "../../../Pagination";
import Swal from "sweetalert2";
import UpdateDynamicGraph from "./UpdateDynamicGraph";
import UseToggle from "../../../../Hooks/UseToggle";

const EDCDynamicGraphList = ({
    Show,
    Hide,
    tableRef,
    onMouseDown,
    setStandardGraphRefresh
}) => {
    const toggles = UseToggle();
    const [graphListLoader, setGraphListLoader] = useState(false);
    const [graphList, setGraphList] = useState([]);
    const [graphData, setGraphData] = useState("");
    const [graphCount, setGraphCount] = useState(0);
    let { studyId } = useParams();

    const [pageNumber, setPageNumber] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(15);
    const startIndex = (pageNumber - 1) * itemsPerPage;
    const totalPage = Math.ceil(graphCount / itemsPerPage);

    const getEDCDashboardGraph = async () => {
        setGraphListLoader(true)
        let data = await studyEDCDashboardGraph.getEDCDashboardGraph(studyId, "edc", pageNumber, itemsPerPage)
        setGraphList(data?.data || [])
        setGraphCount(data?.count || 0)
        setGraphListLoader(false)
    }

    const deleteEDCDashboardGraph = async (id) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "You want to Delete Graph!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#103C5E",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, Delete it!",
        });
        if (result.isConfirmed) {
            const res = await studyEDCDashboardGraph.deleteEDCDashboardGraph(studyId, id);
            if (res?.statusCode === 200) {
                setStandardGraphRefresh(Math.floor(1000000000 + Math.random() * 9000000000));
                getEDCDashboardGraph();
            }
        }
    };

    const updateEDCDashboardGraph = async (id, status) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "You want to Update Graph Status!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#103C5E",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, Update it!",
        });
        if (result.isConfirmed) {
            let userData = {}
            userData.id = id
            userData.studyId = studyId
            userData.status = status
            let data = await studyEDCDashboardGraph.updateEDCDashboardGraph(userData)
            if (data?.statusCode === 200) {
                getEDCDashboardGraph()
                setStandardGraphRefresh(Math.floor(1000000000 + Math.random() * 9000000000));
            }
        }
    }

    useEffect(() => {
        if (Show) {
            getEDCDashboardGraph();
        }
    }, [pageNumber, itemsPerPage, Show]);
    return (
        <>
            <Offcanvas
                show={Show}
                onHide={Hide}
                placement="end"
                style={{ width: 800 }}
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>EDC Graph List</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className="p-0">
                    {graphListLoader ? (
                        <PageLoader />
                    ) : graphList?.length === 0 ? (
                        <div className="hstack justify-content-center h-100">
                            <NoDataFoundTable MSG="Graph list not found!" />
                        </div>
                    ) : (
                        <>
                            <Table
                                id="resizable-table"
                                striped
                                className="m-0 custom-table"
                                ref={tableRef}
                                bordered
                            >
                                <thead className="position-sticky top-0 z-1">
                                    <tr>
                                        <th
                                            className="text-center"
                                            style={{ width: 40 }}
                                            onMouseDown={(e) => onMouseDown(e, 0)}
                                        >
                                            Sr.
                                        </th>
                                        <th onMouseDown={(e) => onMouseDown(e, 1)}>Graph Name</th>
                                        <th onMouseDown={(e) => onMouseDown(e, 2)}>Graph Type</th>
                                        <th onMouseDown={(e) => onMouseDown(e, 4)}>Form</th>
                                        <th onMouseDown={(e) => onMouseDown(e, 5)}>Field</th>
                                        <th style={{ width: 70 }} onMouseDown={(e) => onMouseDown(e, 6)}>Criteria</th>
                                        <th
                                            className="text-center"
                                            style={{ width: 60 }}
                                            onMouseDown={(e) => onMouseDown(e, 7)}
                                        >
                                            Status
                                        </th>
                                        <th
                                            className="text-center"
                                            style={{ width: 40 }}
                                            onMouseDown={(e) => onMouseDown(e, 8)}
                                        >
                                            Edit
                                        </th>
                                        <th
                                            className="text-center"
                                            style={{ width: 50 }}
                                            onMouseDown={(e) => onMouseDown(e, 9)}
                                        >
                                            Delete
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {graphList?.map((item, index) => (
                                        <tr key={index}>
                                            <td className="text-center">{index + 1 + startIndex}</td>
                                            <td style={{whiteSpace : "break-spaces"}}>{item.graphName}</td>
                                            <td>
                                                {item.graphType === "donutGraph" ? "Donut Graph" :
                                                    item.graphType === "paiGraph" ? "Pai Graph" :
                                                        item.graphType === "progressBar" ? "Progress Bar" :
                                                            item.graphType === "radialBar" ? "Radial Bar" :
                                                                item.graphType === "boxPlot" ? "BoxPlot" :
                                                                    item.graphType === "barColumnGraph" ?
                                                                    (item.chartType === "bar" ? "Bar Chart" :
                                                                        item.chartType === "groupedBar" ? "Grouped Bar Chart" :
                                                                            item.chartType === "stackBar" ? "Stack Bar Chart" :
                                                                                item.chartType === "groupedStackBar" ? "Grouped Stack Bar Chart" :
                                                                                    item.chartType === "column" ? "Column Chart" :
                                                                                        item.chartType === "groupColumn" ? "Grouped Column Chart" :
                                                                                            item.chartType === "stackColumn" ? "Stacked Column Chart" :
                                                                                                item.chartType === "groupStackColumn" && "Grouped Stacked Column Chart") : "55"}
                                            </td>
                                            <td style={{whiteSpace : "break-spaces"}}>{item.formCode} {`(${item.formName})`}</td>
                                            <td style={{whiteSpace : "break-spaces"}}>{item.fieldName} {`(${item.fieldLabel})`}</td>
                                            <td>{item.siteType === "siteWise" ? "Site Wise" : "Over All"}</td>
                                            <td
                                                className={`text-center CP fw-bold ${item.status === "active"
                                                    ? "text-success"
                                                    : "text-danger"
                                                    }`}
                                                onClick={() => updateEDCDashboardGraph(item?._id, item.status === "active" ? "inactive" : "active")}
                                            >
                                                {item.status === "active" ? "Active" : "Inactive"}
                                            </td>
                                            <td
                                                title="Edit Graph"
                                                className="text-center CP"
                                                onClick={() => {
                                                    toggles?.setToggle();
                                                    setGraphData(item)
                                                    Hide()
                                                }}
                                            >
                                                <FaEdit />
                                            </td>
                                            <td
                                                title="Delete Graph"
                                                className="text-center CP"
                                                onClick={(e) => deleteEDCDashboardGraph(item?._id)}
                                            >
                                                <FaTrash className="text-danger" />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                            <div className="position-sticky bottom-0 start-0">
                                <Pagination
                                    totalPage={totalPage}
                                    pageNumber={pageNumber}
                                    itemsPerPage={itemsPerPage}
                                    totalItems={graphCount}
                                    setPageNumber={setPageNumber}
                                    setItemsPerPage={setItemsPerPage}
                                />
                            </div>
                        </>
                    )}
                </Offcanvas.Body>
            </Offcanvas>
            <UpdateDynamicGraph
                Show={!toggles.toggle}
                Hide={toggles.setToggle}
                graphData={graphData}
                GraphShowList={Hide}
                getEDCDashboardGraph={getEDCDashboardGraph}
                setStandardGraphRefresh={setStandardGraphRefresh}
            />
        </>
    );
};

export default EDCDynamicGraphList;
